import React, { Component } from 'react'

import TextWithFieldname from '../texts/TextWithFieldname';
import Dico from '../../helpers/Dico';
import ContMessageI18N from '../../containers/ContMessageI18N';
import TableTitle from './TableTitle';

class TableFees extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	render() {
		return (
			<TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
				<TableTitle developperView={this.props.developperView} title={this.props.title} fieldname={this.props.fieldname} />
				<div className="row shadow rounded p-0 m-1 table-responsive">
					<table className="table table-light table-striped">
						<thead>
							<tr className='table-primary'>
								<th className='text-start'>{this.props.developperView ? 'code' : this.getMessage('generics.code')}</th>
								<th className='text-end'>{this.props.developperView ? 'amount.amountExclTax' : this.getMessage('generics.amountExclTax')}</th>
								<th className='text-end'>{this.props.developperView ? 'amount.amountInclTax' : this.getMessage('generics.amountInclTax')}</th>
								<th className='text-start'>{this.props.developperView ? 'imputation' : this.getMessage('fee.imputation')}</th>
							</tr>
						</thead>
						<tbody>
							{this.props.fees.map((line, index) => (
								<tr key={index} >
									<td className='text-start'>{line.code}</td>
									<td className='text-end'>{line.amount && (this.props.developperView ? line.amount.amountExclTax
										: Dico.getAmountFormatted(line.amount, 'HT', this.props.context.countryCode, this.props.context.languageCode))}
									</td>
									<td className='text-end'>{line.amount && (this.props.developperView ? line.amount.amountInclTax
										: Dico.getAmountFormatted(line.amount, 'TC', this.props.context.countryCode, this.props.context.languageCode))}
									</td>
									<td className='text-start'>{line.imputation}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</TextWithFieldname>
		)
	}
}

export default (TableFees)
